import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs';
import { map }        from 'rxjs/operators';

import { Course } 		 from '../../models/api/course.model';

import { AppConfigurationService } from '../configuration/app-configuration.service';

@Injectable({
    providedIn: 'root'
})
export class CourseService {

    private apiURL : string;

    private courseActiveData  = new Subject<Course>();
    public  courseActiveData$ = this.courseActiveData.asObservable();

    constructor(private http: HttpClient, private appConfigurationService: AppConfigurationService) { 

        this.apiURL = this.appConfigurationService.baseApi + '/course';

    }

    getCourseByUrl(courseurl: string): any {

        const url = this.apiURL + '/url/' + courseurl;
        return this.http.get<Course>(url).pipe(
            map((data) => {
                this.courseActiveData.next(data);
            })
        );
        
    }

}
